import Header from "../components/header";
import React from "react";

const PrivacyPolicy = () => {
  <Header />;
  return (
    <div className="bg-[#F2F1F6] py-8 lg:py-16 lg:px-12">
      <h1 className="mb-10 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl text-[#016A9E] text-center">
        Privacy Policy
      </h1>
      <div className="text-gray-700">
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          This Privacy Policy ("Policy") outlines how Essay Writer Pro ("we,"
          "us," or "our") collects, uses, and protects your information when you
          use our website and services ("Services").
        </p>
        <h2 className="mb-8 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Information We Collect:
        </h2>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Information You Provide Directly:
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold">Order Details:</span> Information
          related to your writing service requests, such as assignment
          requirements, instructions, and deadlines.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> Account Information:</span> When you
          create an account with Essay Writer Pro, you may provide personally
          identifiable information ("PII") such as your name, email address, and
          payment details.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Information Collected Automatically:
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold">Usage Data:</span> We collect data about
          how you interact with our website, including the pages you visit and
          the features you use.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> Device Information:</span> We gather
          details about the device you use to access our Services, such as
          device type, operating system, and unique device identifiers.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Use of Your Information
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We use the information we collect for the following purposes:
        </p>
        <p className="mb-8 ml-6 text-lg lg:text-xl sm:px-16 xl:px-48 font-bold">
          <p className="font-bold">
            {" "}
            - To provide and operate Essay Writer Pro services
          </p>
          <p className="font-bold">
            {" "}
            - To improve and personalize your experience
          </p>
          <p className="font-bold">
            {" "}
            - To develop and enhance our services To provide customer support
          </p>
          <p className="font-bold">
            - To send you marketing and promotional communications (with your
            consent)
          </p>
          <p className="font-bold">
            {" "}
            - To analyze and understand usage patterns on our website
          </p>
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Payment and Subscriptions
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Essay Writer Pro offers paid services for writing assignments. We use
          your payment information to process your orders securely. We may store
          payment information for future transactions if you choose to do so.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Sharing of Your Information
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We may share your information with third-party service providers who
          assist us in operating and improving our services. These providers are
          contractually obligated to keep your information confidential and
          secure. We will not share your PII with any third party for marketing
          purposes without your explicit consent.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Data Retention
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We retain your information for as long as your account is active or as
          necessary to provide our services. We may also retain your information
          to comply with legal obligations or resolve disputes.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Security
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We take reasonable measures to protect your information from
          unauthorized access, disclosure, alteration, or destruction. However,
          no method of online transmission or electronic storage is completely
          secure.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Your Choices
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          You can access and update your account information at any time through
          your account settings. You can also opt out of receiving marketing
          communications by following the instructions provided in those emails.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Children's Privacy
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Our services are not intended for children under the age of 13. We do
          not knowingly collect information from children under 13. If you are a
          parent or guardian and believe your child has provided us with
          information, please contact us immediately.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Changes to This Policy
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We may update this Policy occasionally. We will notify you of any
          significant changes by posting the new Policy on this page and
          updating the date at the top.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Contact Us
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          If you have any questions or concerns about our Privacy Policy or our
          practices, please do not hesitate to reach out to us. You can contact
          us at:
          <a
            href="mailto:info@thekaizenglobal.com"
            className="text-[#ba56d4] hover:underline"
          >
            {" "}
            info@thekaizenglobal.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
